import { REHYDRATE } from "redux-persist";
import { IntlActionTypes } from "./actioner";

const initialState = {
  intlOverrides: [],
};

const IntlReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
        intlOverrides: action?.payload?.Intl?.intlOverrides ?? [],
      };
    case IntlActionTypes.SET_INTL_OVERRIDES:
      return {
        ...state,
        intlOverrides: action.overrides,
      };
    default:
      return state;
  }
};

export default IntlReducer;
